import { Grid } from "@mui/material";
import { SupplierFormProps } from "../SupplierFormProps";
import { SupplierOptionalAddressForm } from "./SupplierOptionalAddressForm";
import { SupplierOptionalCoordinatesForm } from "./SupplierOptionalCoordinatesForm";

export const SupplierOptionalForm = ({ disabledFields }: SupplierFormProps) => {
  return (
    <Grid container columnSpacing={1}>
      <Grid item xs={9}>
        <SupplierOptionalAddressForm disabledFields={disabledFields} />
      </Grid>
      <Grid item xs={3}>
        <SupplierOptionalCoordinatesForm disabledFields={disabledFields} />
      </Grid>
    </Grid>
  );
};
